import React, { useState, useMemo, useEffect } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import urlJoin from 'url-join';
import PropTypes from 'prop-types';

import Search from '../../webcommon/common/Icons/Search.svg';

import styles from './IdSearch.module.scss';
import { getVirtualDirectory } from '../../common/helpermethods/HelperMethods';

const IdSearch = (props) => {
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        setSearchText('');
    }, [props.history.location.pathname]);

    const handleChange = (event) => {
        setSearchText(event.target.value);
    };

    const path = useMemo(() => urlJoin(getVirtualDirectory(), `impactanalysis/${searchText}`), [searchText]);

    const clickLink = (event) => {
        if (event.keyCode === 13) {
            event.preventDefault();
            props.history.push(path);
        }
    };

    return (
        <div className={ styles.searchboxWrapper }>
            <div className={ styles.titleWrapper }>
                Search Impact Analysis ID
            </div>
            <div className={ styles.searchBarWrapper }>
                <input className={ styles.searchBar } onChange={ handleChange } onKeyUp={ clickLink } value={ searchText } />
                <Link
                    to={ path }
                    replace
                    id="link"
                    className={ styles.searchButtonWrapper }
                >
                    <img
                        alt="Search"
                        src={ Search }
                        className={ styles.svg }
                    />
                </Link>
            </div>
        </div>
    );
};

IdSearch.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        location: PropTypes.shape({
            pathname: PropTypes.string
        })
    }).isRequired
};

export default withRouter(IdSearch);
